// extracted by mini-css-extract-plugin
export default {"container":"ReferencesBlock_container__r9X38","title":"ReferencesBlock_title__j9S7-","subtitle":"ReferencesBlock_subtitle__vSkyI"};